

exports.__esModule = true;
exports.$xoSepaPageComponent = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-models/src/checkout/index');

require('components/xo-page-components/src/value-props/directive');

require('components/xo-return-to-merchant/dist/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
    tag: 'xo-sepa-page',
    template: _template2['default'],

    scope: {
        token: '='
    },

    controller: function controller($scope, $state, $populate, $ReturnToMerchant, $CheckoutAppDataModel, $CheckoutSessionModel) {
        $scope.callbacks = {
            success: function success(sepaModel) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    return sepaModel.action('clearSepa', {

                        data: {
                            bank: {
                                id: sepaModel.bankId
                            },
                            token: $scope.token
                        },

                        success: function success() {
                            $scope.checkoutSession.action('authorize', {
                                success: function success() {
                                    $state.go('checkout.end');
                                }

                            });
                        }

                    });
                });
            }
        };
        $state.go('checkout.sepapage.membersepa.sepaAgreement');
    }

});

angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sepa/directive.js
 ** module id = 431
 ** module chunks = 1
 **/